import React from 'react';

import {
  Box,
  ButtonBase,
  ButtonBaseProps,
  CircularProgress,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { useStyles } from './AppIconPillButton.styles';

export type IconPillVariant = 'primary' | 'secondary';

export interface IAppIconPillButtonProps extends ButtonBaseProps {
  colorVariant?: IconPillVariant;
  loading?: boolean;
}

export function AppIconPillButton({
  colorVariant = 'secondary',
  className,
  children,
  loading = false,
  disabled,
  ...props
}: IAppIconPillButtonProps) {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const isDisabled = disabled || loading;

  return (
    <Box
      component="span"
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <ButtonBase
        className={clsx(classes.button, classes[colorVariant], className)}
        disabled={isDisabled}
        {...props}>
        <span className={classes.content}>{children}</span>
      </ButtonBase>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            marginLeft: '-12px',
            marginTop: '-12px',
          }}
        />
      )}
    </Box>
  );
}

export default AppIconPillButton;
